import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('[ErrorBoundary]', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#F5F7FA',
                    fontFamily: 'system-ui, sans-serif',
                    padding: '24px'
                }}>
                    <div style={{
                        maxWidth: '480px',
                        textAlign: 'center',
                        background: '#fff',
                        borderRadius: '16px',
                        padding: '40px 32px',
                        boxShadow: '0 4px 24px rgba(0,0,0,0.08)'
                    }}>
                        <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
                        <h1 style={{ fontSize: '20px', fontWeight: 600, color: '#1a1a1a', margin: '0 0 8px' }}>
                            Erro ao carregar o RecepPet
                        </h1>
                        <p style={{ fontSize: '14px', color: '#666', margin: '0 0 24px', lineHeight: 1.5 }}>
                            Ocorreu um erro inesperado. Tente recarregar a página.
                        </p>
                        <button
                            onClick={() => window.location.reload()}
                            style={{
                                background: '#4A90B2',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '8px',
                                padding: '12px 24px',
                                fontSize: '14px',
                                fontWeight: 500,
                                cursor: 'pointer'
                            }}
                        >
                            Recarregar página
                        </button>
                        {this.state.error && (
                            <details style={{ marginTop: '24px', textAlign: 'left', fontSize: '12px', color: '#999' }}>
                                <summary style={{ cursor: 'pointer' }}>Detalhes técnicos</summary>
                                <pre style={{
                                    marginTop: '8px',
                                    padding: '12px',
                                    background: '#f5f5f5',
                                    borderRadius: '8px',
                                    overflow: 'auto',
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word'
                                }}>
                                    {this.state.error.toString()}
                                </pre>
                            </details>
                        )}
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
